import { FC } from "react"
import { useConfiguration } from "../../hooks/useConfiguration";
import { PartnersWidget } from "./Partners";
import { SiteMap } from "../../layout/legacy/sitemap";
import { SocialLinksList } from "../social/SocialLinks";

export const LegacyDesktopFooter: FC = () => {
    const config = useConfiguration();
    const hidePartners = false;
    return (
        <div className="bg-slate-900 pb-5">
            <div className="mx-auto px-10 py-5">
                {!hidePartners && <PartnersWidget teamName={config.teamName} />}
            </div>
            <div className="max-w-full py-5 mx-auto">
                <SiteMap teamContext={config.teamName} />
            </div>
            <div className="px-10 py-5 w-full">
                <SocialLinksList teamContext={config.teamName} color="white" className="!gap-3 ml-3" iconClassName="!h-10 !w-10 sm:!h-12 sm:!w-12" />
            </div>
        </div>
    );
}